function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
const DonePending = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 221,
  height: 126,
  fill: "none"
}, props), /*#__PURE__*/React.createElement(G, {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#545F71",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M29.083 89.208h44.933m-44.933 25.387h44.933m-44.933-12.687h44.933M3.679 124.849h185.359m-6.762-51.452v51.452m-46.535-52.103v52.103m-42.418-57.92h51.85M20.589 124.85V78.472h61.92v46.377m13.094-56.006v56.006M9.046 68.843v56.006m50.509-81.446h71.796l23.789 17.294m33.924 17.216-29.795-19.806-32.543 20.378m-23.685-4.36-50.69-35.953L.877 74.946m123.764 50.125V91.147h-17.718v33.924m62.168-23.332h-20.167V81.465h20.167v20.274Z"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  stroke: "#111C2B",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M167.829 104.419c28.37 0 51.368-22.971 51.368-51.309 0-28.337-22.998-51.309-51.368-51.309s-51.369 22.972-51.369 51.31c0 28.337 22.999 51.308 51.369 51.308Z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M176.606 27.081h14.695v55.213h-46.602V27.081h14.683"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m164.38 22.705-4.998 4.376v6.197h17.224V27.08l-4.986-4.376h-7.24ZM167.377 51.53v4.315h-14.815V39.92h11.746"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m156.925 46.189 4.363 4.388 8.522-8.572M167.377 70.239v4.316h-14.815V62.728"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m156.925 64.898 4.363 4.388 8.522-8.57"
})), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
  id: "a"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M.5.5h220v125H.5z"
}))));
export default DonePending;
//# sourceMappingURL=DonePending.js.map